import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from '@barthauer/abc/core/authentication';
import { AppService } from '../services/app.service';
import { ResourceEventMaterialMaterialExpenseComponent } from './resource-event-material-material-expense/resource-event-material-material-expense.component';
import { ResourceEventOtherOtherComponent } from './resource-event-other-other/resource-event-other-other.component';
import { ResourceEventPersonnelWorkingTimesComponent } from './resource-event-personnel-working-times/resource-event-personnel-working-times.component';
import { ResourceEventVehicleDowntimeComponent } from './resource-event-vehicle-downtime/resource-event-vehicle-downtime.component';
import { ResourceEventVehicleMileageComponent } from './resource-event-vehicle-mileage/resource-event-vehicle-mileage.component';
import { ResourceEventVehicleOperatingHoursComponent } from './resource-event-vehicle-operating-hours/resource-event-vehicle-operating-hours.component';
import { ResourceEventVehicleWaterFillingComponent } from './resource-event-vehicle-water-filling/resource-event-vehicle-water-filling.component';
import { ResourceListComponent } from './resource-list/resource-list.component';

const reuseDetailPageInstances: boolean = false;

const resourcesRoutes: Routes = [
  {
    path: AppService.Route_ResourceList,
    component: ResourceListComponent,
    data: { animation: AppService.Route_ResourceList, reuse: true, mainOutletName: 'mainOutlet' },
    canActivate: [AuthenticationGuard],
    outlet: AppService.RouterOutlet_Resources,
  },
  {
    path: AppService.Route_ResourceEventVehicleMileage,
    component: ResourceEventVehicleMileageComponent,
    data: {
      animation: AppService.Route_ResourceEventVehicleMileage,
      reuse: reuseDetailPageInstances,
      mainOutletName: 'mainOutlet',
    },
    canActivate: [AuthenticationGuard],
    outlet: AppService.RouterOutlet_Resources,
  },
  {
    path: AppService.Route_ResourceEventVehicleOperatingHours,
    component: ResourceEventVehicleOperatingHoursComponent,
    data: {
      animation: AppService.Route_ResourceEventVehicleOperatingHours,
      reuse: reuseDetailPageInstances,
      mainOutletName: 'mainOutlet',
    },
    canActivate: [AuthenticationGuard],
    outlet: AppService.RouterOutlet_Resources,
  },
  {
    path: AppService.Route_ResourceEventVehicleDowntime,
    component: ResourceEventVehicleDowntimeComponent,
    data: {
      animation: AppService.Route_ResourceEventVehicleDowntime,
      reuse: reuseDetailPageInstances,
      mainOutletName: 'mainOutlet',
    },
    canActivate: [AuthenticationGuard],
    outlet: AppService.RouterOutlet_Resources,
  },
  {
    path: AppService.Route_ResourceEventVehicleWaterFilling,
    component: ResourceEventVehicleWaterFillingComponent,
    data: {
      animation: AppService.Route_ResourceEventVehicleWaterFilling,
      reuse: reuseDetailPageInstances,
      mainOutletName: 'mainOutlet',
    },
    canActivate: [AuthenticationGuard],
    outlet: AppService.RouterOutlet_Resources,
  },
  {
    path: AppService.Route_ResourceEventPersonnelWorkingTimes,
    component: ResourceEventPersonnelWorkingTimesComponent,
    data: {
      animation: AppService.Route_ResourceEventPersonnelWorkingTimes,
      reuse: reuseDetailPageInstances,
      mainOutletName: 'mainOutlet',
    },
    canActivate: [AuthenticationGuard],
    outlet: AppService.RouterOutlet_Resources,
  },
  {
    path: AppService.Route_ResourceEventMaterialMaterialExpense,
    component: ResourceEventMaterialMaterialExpenseComponent,
    data: {
      animation: AppService.Route_ResourceEventMaterialMaterialExpense,
      reuse: reuseDetailPageInstances,
      mainOutletName: 'mainOutlet',
    },
    canActivate: [AuthenticationGuard],
    outlet: AppService.RouterOutlet_Resources,
  },
  {
    path: AppService.Route_ResourceEventOtherOther,
    component: ResourceEventOtherOtherComponent,
    data: {
      animation: AppService.Route_ResourceEventOtherOther,
      reuse: reuseDetailPageInstances,
      mainOutletName: 'mainOutlet',
    },
    canActivate: [AuthenticationGuard],
    outlet: AppService.RouterOutlet_Resources,
  },
];

@NgModule({
  imports: [RouterModule.forChild(resourcesRoutes)],
  exports: [RouterModule],
})
export class ResourcesRoutingModule {}
